import { animate, group, query, style, transition, trigger } from '@angular/animations'

const fade = [group([query(':self', [style({ opacity: 0 }), animate('600ms ease-in-out', style({ opacity: 1 }))])])]

export const routerTransition = trigger('routeTransitions', [transition('* => *', fade)])
